import { useState, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export function usePlaylistCover() {
  const [generating, setGenerating] = useState<string | null>(null);

  const generateCover = useCallback(async (playlistId: string): Promise<string | null> => {
    setGenerating(playlistId);
    try {
      const { data, error } = await supabase.functions.invoke("generate-playlist-cover", {
        body: { playlist_id: playlistId },
      });

      if (error) {
        console.error("Cover generation error:", error);
        toast.error("Failed to generate cover");
        return null;
      }

      if (data?.error) {
        if (data.error.includes("Maximum")) {
          toast.error("You've used all 4 cover generations for this playlist");
        } else {
          toast.error(data.error);
        }
        return null;
      }

      toast.success(`Cover generated! (${data.style} style)`);
      return data.cover_image_url;
    } catch (e) {
      console.error("Cover generation failed:", e);
      toast.error("Cover generation failed");
      return null;
    } finally {
      setGenerating(null);
    }
  }, []);

  return { generateCover, generating };
}
